import { CATEGORY_TYPES, SEARCH_TYPES_KEYS } from '../constants';
import { useExpiryFilterWithAdmin } from './knowledge.hooks';

export const useSearchResultsPreparation = (
  filters,
  searchType = SEARCH_TYPES_KEYS.none,
  adminMode = false,
  isContactsEnabled,
) => {
  const expiryFilter = useExpiryFilterWithAdmin({ adminMode });

  const { filtersByTags = () => true } = filters;

  const filterKnowledgeByType = thumbnail => {
    if (searchType === SEARCH_TYPES_KEYS.none) return false;

    if (![SEARCH_TYPES_KEYS.documents, SEARCH_TYPES_KEYS.media].includes(searchType)) return true;

    return searchType !== SEARCH_TYPES_KEYS.documents ? thumbnail === '' : !!thumbnail;
  };

  const filterLabByType = () =>
    [SEARCH_TYPES_KEYS.none, SEARCH_TYPES_KEYS.compendium].includes(searchType);

  const filterAdmissionByType = () =>
    [SEARCH_TYPES_KEYS.none, SEARCH_TYPES_KEYS.admission].includes(searchType);

  const filterContactsByType = () =>
    [SEARCH_TYPES_KEYS.none, SEARCH_TYPES_KEYS.contacts].includes(searchType);

  const prepareResults = results => {
    if (results === null) return {};

    const knowledgeItems = results.knowledge
      .filter(
        ({ item }) =>
          expiryFilter(item) && !filterKnowledgeByType(item.thumbnail) && filtersByTags(item),
      )
      .slice(0, 50);
    const labItems = results.lab.filter(filterLabByType).filter(filtersByTags).slice(0, 50);
    const admissionItems = results.admission
      .filter(({ type }) => filterAdmissionByType() && type === CATEGORY_TYPES.CHECKS)
      .filter(filtersByTags)
      .slice(0, 50);
    const contactItems = isContactsEnabled
      ? results.contacts
          ?.filter(filterContactsByType)
          .slice(0, 50)
          .sort(({ item: a }, { item: b }) => a.firstName.localeCompare(b.firstName))
      : [];

    const resultsCount = [
      knowledgeItems.length,
      labItems.length,
      admissionItems.length,
      contactItems.length,
    ].reduce((acc, curr) => acc + curr, 0);

    return {
      knowledgeItems,
      labItems,
      admissionItems,
      contactItems,
      resultsCount,
    };
  };

  return {
    prepareResults,
  };
};
